import { Dropdown, Pagination, Space, Tooltip } from "antd";
import React, { useState } from "react";
import { AiTwotoneSetting } from "react-icons/ai";
import {
  FaEdit,
  FaEllipsisV,
  FaEye,
  FaEyeSlash,
  FaInfoCircle,
  FaTrashRestoreAlt,
} from "react-icons/fa";
import { IconPickerItem } from "react-fa-icon-picker";
import { Link } from "react-router-dom";
import Alert from "../../../../../global/alert/Alert";
import {
  useDelete,
  useStatusChange,
} from "../../../../../../utils/CustomFunctions";
import { MdDelete } from "react-icons/md";
import { IoCloseSharp } from "react-icons/io5";

const CategoriesTable = ({ categories }) => {
  const server = process.env.REACT_APP_SERVER;
  // this is alert maessage
  const msg = {
    icon: <FaInfoCircle className="me-3" />,
    type: "alert-info",
    text: "No categories found",
  };

  // for state change
  const { loading, handleStatusChange } = useStatusChange(
    "admin",
    "event_category_change_status",
    "event_categories",
    "event_categories"
  );
  // for soft delete and parmanently delete
  const { isLoading, handleDelete } = useDelete(
    "admin",
    "event_categories",
    "event_categories"
  );

  // for pagination purposes
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const indexOfLastData = currentPage * itemsPerPage;
  const indexOfFirstData = indexOfLastData - itemsPerPage;
  const currentData = categories?.slice(indexOfFirstData, indexOfLastData);

  return (
    <>
      <div className="row organizer-event">
        <div className="col-12">
          {categories && categories.length > 0 ? (
            <div className="card">
              <div className="table-responsive">
                <table className="table table-hover table-vcenter">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Events count</th>
                      <th>Icon</th>
                      <th>Image</th>
                      <th>Is featured</th>
                      <th>Status</th>
                      <th className="text-center">
                        <AiTwotoneSetting />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentData?.map((category) => {
                      const items = [
                        {
                          label: (
                            <Link
                              to={`${category.id}/edit`}
                              className="d-flex align-items-center"
                            >
                              <FaEdit className="me-1" />
                              Edit
                            </Link>
                          ),
                          key: "0",
                        },
                        {
                          label: (
                            <Link
                              to=""
                              className="d-flex align-items-center"
                              onClick={(e) =>
                                handleStatusChange(e, category.id)
                              }
                            >
                              {category.status === "visible" ? (
                                <>
                                  <FaEyeSlash className="me-1" />
                                  Hidden
                                </>
                              ) : (
                                <>
                                  <FaEye className="me-1" /> Visible
                                </>
                              )}
                            </Link>
                          ),
                          key: "1",
                        },
                        {
                          label: (
                            <Link
                              to=""
                              className="d-flex align-items-center"
                              onClick={(e) =>
                                handleDelete(
                                  e,
                                  category.id,
                                  "event_category_delete",
                                  ""
                                )
                              }
                            >
                              {category.deleted_at !== null ? (
                                <>
                                  <FaTrashRestoreAlt className="me-1" /> Restore
                                </>
                              ) : (
                                <>
                                  <IoCloseSharp className="me-1" />
                                  Delete
                                </>
                              )}
                            </Link>
                          ),
                          key: "3",
                        },
                        category.deleted_at && {
                          label: (
                            <Link
                              to=""
                              className="d-flex align-items-center"
                              onClick={(e) =>
                                handleDelete(
                                  e,
                                  category.id,
                                  "event_category_delete_permanent",
                                  "delete_permanent"
                                )
                              }
                            >
                              <MdDelete className="me-1" />
                              Delete permanently
                            </Link>
                          ),
                          key: "4",
                        },
                      ];
                      return (
                        <tr key={category.id}>
                          <td className="text-capitalize">{category.name}</td>
                          <td>{category.events_count}</td>
                          <td>
                            {category.icon && (
                              <IconPickerItem
                                icon={category.icon}
                                size={24}
                                color="#000"
                              />
                            )}
                          </td>

                          <td>
                            <Tooltip title="Enlarge">
                              {category?.image ? (
                                <Link
                                  className="fancybox"
                                  to={`${server}/event/category/image/${category.image}`}
                                  target="_blank"
                                >
                                  <img
                                    src={`${server}/event/category/image/${category.image}`}
                                    className="img-thumbnail img-50-50"
                                  />
                                </Link>
                              ) : (
                                <img
                                  src="/./images/noPhoto.png"
                                  className="img-thumbnail img-50-50"
                                  alt=""
                                />
                              )}
                            </Tooltip>
                          </td>
                          <td>
                            {category.featured !== null
                              ? `Yes ( Order ${category.featured} ) `
                              : "No"}
                          </td>
                          <td className="">
                            <span
                              className={`badge badge-${
                                category.status === "visible"
                                  ? "success"
                                  : "danger"
                              } d-inline-flex align-items-center`}
                            >
                              {category.status === "visible" ? (
                                <>
                                  <FaEye className="me-1" /> Visible
                                </>
                              ) : (
                                <>
                                  <FaEyeSlash className="me-1" />
                                  Hidden
                                </>
                              )}
                            </span>

                            {category.deleted_at && (
                              <>
                                <br />
                                <br />
                                <span className="badge badge-danger d-inline-flex align-items-center">
                                  <IoCloseSharp className="me-1" />
                                  Deleted
                                </span>
                              </>
                            )}
                          </td>
                          <td className="text-center">
                            <Dropdown
                              className="table-dropdown"
                              menu={{
                                items,
                              }}
                              trigger={["click"]}
                            >
                              <a onClick={(e) => e.preventDefault()}>
                                <Space>
                                  <FaEllipsisV />
                                </Space>
                              </a>
                            </Dropdown>
                            ;
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <Alert {...msg} />
          )}
        </div>
      </div>

      {categories?.length > 10 && (
        <Pagination
          current={currentPage}
          total={categories.length}
          pageSize={itemsPerPage}
          onChange={handlePageChange}
        />
      )}
    </>
  );
};
export default CategoriesTable;
